import { FC } from 'react';

import { useLkBasePath } from '../../../../../hooks/use-lk-base-path';
import { ArrowsPayments1V4Icon } from '../../../../icons/ArrowsPayments1V4Icon';
import { ArrowsPayments2V4Icon } from '../../../../icons/ArrowsPayments2V4Icon';
import { ArrowsPayments3V4Icon } from '../../../../icons/ArrowsPayments3V4Icon';
import { ArrowsPayments4V4Icon } from '../../../../icons/ArrowsPayments4V4Icon';
import { Box } from '../../../common/Box';
import { ButtonLink } from '../../../common/ButtonLink';
import { Flex } from '../../../common/Flex';
import { Text } from '../../../common/Text';

import styles from './ProcessorSection.module.scss';

export const ProcessorSection: FC = () => {
  const lkBasePath = useLkBasePath();

  return (
    <Flex direction={'column'} gap={4} className={styles.root}>
      <div className={styles.titleWrapper}>
        <Text type={'h2'}>
          Everything you need in
          <br /> a modern payment processor
        </Text>
      </div>

      <div className={styles.grid}>
        <Box
          iconIn={<ArrowsPayments1V4Icon />}
          iconOut={<ArrowsPayments2V4Icon />}
          title="Pay-ins (Online payments)"
          description="Accept cards, wallets, bank transfers and local methods with one integration"
        />

        <Box
          iconIn={<ArrowsPayments2V4Icon />}
          iconOut={<ArrowsPayments1V4Icon />}
          title="Pay-outs (Mass payouts)"
          description="Send funds to customers, partners and workforce across key payout rails"
        />

        <Box
          iconIn={<ArrowsPayments3V4Icon />}
          iconOut={<ArrowsPayments4V4Icon />}
          title="Add payment methods"
          description="Accept cards, wallets, bank transfers and local methods with one integration"
        />

        <Box
          iconIn={<ArrowsPayments4V4Icon />}
          iconOut={<ArrowsPayments3V4Icon />}
          title="Checkout & Risk"
          description="Conversion-focused checkout flows and built-in risk controls"
        />
      </div>

      <ButtonLink href={`${lkBasePath}/registration`} isOutsideLink>
        Start processing
      </ButtonLink>
    </Flex>
  );
};
